(() => {
  if (window.BlakoCollectionColourSwatchesLoaded) return;
  window.BlakoCollectionColourSwatchesLoaded = true;

  const getCard = (element) => element.closest('.card-wrapper');

  const updateColourName = (card, swatch) => {
    if (!card) return;

    const label = card.querySelector('[data-blako-colour-name]');
    if (!label) return;

    const colourName = swatch?.getAttribute('title') || swatch?.getAttribute('aria-label') || '';
    if (!colourName) {
      label.hidden = true;
      label.replaceChildren();
      return;
    }

    const cleanName = colourName.replace(/\s+-\s+Sold out$/i, '');
    const isUnavailable = swatch?.classList.contains('is-unavailable');

    const name = document.createElement('span');
    name.className = 'blako-collection-card__colour-value';
    name.textContent = cleanName;

    label.replaceChildren(name);

    if (isUnavailable) {
      const status = document.createElement('span');
      status.className = 'blako-collection-card__stock-status';
      status.textContent = ' — OUT OF STOCK';
      label.append(status);
    }

    label.hidden = false;
  };

  const updateArrowVisibility = (group) => {
    if (!group) return;

    const viewport = group.querySelector('[data-blako-swatches-viewport]');
    const desktopButton = group.querySelector('.blako-card-colours__next--desktop');
    const mobileButton = group.querySelector('.blako-card-colours__next--mobile');
    if (!viewport) return;

    // Measure against the full available card width first. The arrow itself must
    // not create the overflow condition that causes it to appear.
    if (desktopButton) desktopButton.hidden = true;
    if (mobileButton) mobileButton.hidden = true;

    requestAnimationFrame(() => {
      const hasHiddenSwatches = viewport.scrollWidth > viewport.clientWidth + 1;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const activeButton = isMobile ? mobileButton : desktopButton;

      if (activeButton) activeButton.hidden = !hasHiddenSwatches;

      // If resizing made all swatches fit again, reset any previous scroll.
      if (!hasHiddenSwatches && viewport.scrollLeft !== 0) {
        viewport.scrollLeft = 0;
      }
    });
  };

  const updateAllArrowVisibility = () => {
    document.querySelectorAll('[data-blako-card-colours]').forEach((group) => {
      updateArrowVisibility(group);

      const card = getCard(group);
      const selectedSwatch =
        group.querySelector('[data-blako-colour-swatch].is-selected') ||
        group.querySelector('[data-blako-colour-swatch]');
      updateColourName(card, selectedSwatch);
    });
  };

  const selectSwatch = (swatch) => {
    const card = getCard(swatch);
    if (!card) return;

    const group = swatch.closest('[data-blako-card-colours]');
    const variantUrl = swatch.dataset.variantUrl;
    const variantId = swatch.dataset.variantId;
    const imageSrc = swatch.dataset.imageSrc;
    const imageSrcset = swatch.dataset.imageSrcset;

    if (group) {
      group.querySelectorAll('[data-blako-colour-swatch]').forEach((item) => {
        const selected = item === swatch;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    updateColourName(card, swatch);

    if (imageSrc) {
      const primaryImage = card.querySelector('.card__media .media > img:first-child');
      if (primaryImage) {
        primaryImage.src = imageSrc;
        if (imageSrcset) primaryImage.srcset = imageSrcset;
        else primaryImage.removeAttribute('srcset');

        if (swatch.dataset.imageWidth) primaryImage.width = Number(swatch.dataset.imageWidth);
        if (swatch.dataset.imageHeight) primaryImage.height = Number(swatch.dataset.imageHeight);
        if (swatch.dataset.imageAlt) primaryImage.alt = swatch.dataset.imageAlt;
      }
      card.classList.add('blako-card-variant-active');
    }

    if (variantUrl) {
      card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
        link.href = variantUrl;
      });
    }

    if (variantId) {
      card.querySelectorAll('form input[name="id"]').forEach((input) => {
        input.value = variantId;
      });
    }
  };

  const showMoreSwatches = (button) => {
    const group = button.closest('[data-blako-card-colours]');
    const viewport = group?.querySelector('[data-blako-swatches-viewport]');
    if (!viewport) return;

    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const atEnd = viewport.scrollLeft >= maxScroll - 2;

    if (atEnd) {
      viewport.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      viewport.scrollBy({ left: Math.max(viewport.clientWidth * 0.82, 48), behavior: 'smooth' });
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-blako-colour-swatch]');
    if (swatch) {
      event.preventDefault();
      event.stopPropagation();
      selectSwatch(swatch);
      return;
    }

    const next = event.target.closest('[data-blako-swatches-next]');
    if (next) {
      event.preventDefault();
      event.stopPropagation();
      showMoreSwatches(next);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllArrowVisibility, { once: true });
  } else {
    updateAllArrowVisibility();
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateAllArrowVisibility, 80);
  });

  document.addEventListener('shopify:section:load', updateAllArrowVisibility);
  document.addEventListener('blako:content:loaded', updateAllArrowVisibility);
})();
